export default "__VITE_ASSET__IAzis6tN__"